import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {actionSetNewAddress, actionUpdateAddress} from 'modules/addresses/slice';
import {addNewAddress, deleteAddress, updateAddress} from 'modules/addresses/thunks';
import {useIsLoggedIn} from 'modules/user/hooks/useIsLoggedIn';
import {useCallback, useId} from 'react';

export const useDeliveryAddressesActions = () => {
    const dispatch = useAppDispatch();
    const isLoggedIn = useIsLoggedIn();
    const uid = useId();

    const create = useCallback(
        (payload: Parameters<typeof addNewAddress>['0']) => {
            if (!isLoggedIn) {
                dispatch(
                    actionSetNewAddress({
                        ...payload,
                        id: uid,
                        isDefault: true,
                    })
                );
                return;
            }
            dispatch(addNewAddress(payload));
        },
        [dispatch, isLoggedIn, uid]
    );
    const update = useCallback(
        (payload: Parameters<typeof updateAddress>['0']) => {
            if (!isLoggedIn) {
                dispatch(
                    actionUpdateAddress({
                        ...payload.body,
                        address: payload.body.address ?? '',
                        id: payload.id,
                        isDefault: true,
                    })
                );
                return;
            }

            dispatch(updateAddress(payload));
        },
        [dispatch, isLoggedIn]
    );
    const remove = useCallback(
        (payload: Parameters<typeof deleteAddress>['0']) => dispatch(deleteAddress(payload)),
        [dispatch]
    );

    return {
        create,
        remove,
        update,
    };
};
